import { render, staticRenderFns } from "./TableBudgetStaffPending.vue?vue&type=template&id=1935e364&"
import script from "./TableBudgetStaffPending.vue?vue&type=script&lang=ts&"
export * from "./TableBudgetStaffPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports